import React from "react";
import { Switch, Route } from "wouter";
import { queryClient } from './lib/queryClient.js';
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from './components/ui/toaster.js';
import NotFound from './pages/not-found.js';
import Home from './pages/Home.js';
import ServiceDetails from './pages/ServiceDetails.tsx';
import Booking from './pages/Booking.tsx';
import Contact from './pages/Contact.jsx';
import Services from './pages/Services';
import Telecom from './pages/Telecom.js';
import Header from './components/layout/Header.js';
import Footer from './components/layout/Footer.js';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import Pricing from './pages/Pricing.js';
import ChatWidget from './components/ui/ChatWidget.js';
import AdminPage from './pages/AdminPage.jsx';
import PrivacyPolicy from './pages/PrivacyPolicy.js';
import TermsOfService from './pages/TermsOfService.js';
import CookiePolicy from './pages/CookiePolicy.js';
import AboutUs from './pages/AboutUs.js';

// Inside your Routes component

function Router() {
  return (
    <HelmetProvider>
      <div className="flex flex-col min-h-screen bg-neutral text-dark">
        <Helmet>
          <title>Phone, Laptop & Console Repair in North York | ZiwaTech</title>
        </Helmet>
        <Header />
        <main className="flex-grow">
          <Switch>
            <Route path="/" component={Home} />
            <Route path="/services" component={Services} />
            <Route path="/services/:slug" component={ServiceDetails} />
            <Route path="/telecom" component={Telecom} />
            <Route path="/booking" component={Booking} />
            <Route path="/contact" component={Contact} />
            <Route path="/pricing" component={Pricing} />
            <Route path="/admin" component={AdminPage} />
            <Route path="/privacy-policy" component={PrivacyPolicy} />
            <Route path="/terms-of-service" component={TermsOfService} />
            <Route path="/cookie-policy" component={CookiePolicy} />
            <Route path="/about-us" component={AboutUs} />
            <Route component={NotFound} />
          </Switch>
        </main>
        <Footer />
        <ChatWidget />
      </div>
    </HelmetProvider>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router />
      <Toaster />
    </QueryClientProvider>
  );
}

export default App;